import { render, staticRenderFns } from "./QuestionImgAb.vue?vue&type=template&id=d9e4b036&"
import script from "./QuestionImgAb.vue?vue&type=script&lang=ts&"
export * from "./QuestionImgAb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports